<div class="toolbar-sticky border-bottom bg-light sticky-top mb-2 d-print-m-0 align-items-start" id="toolbar-sticky" *transloco="let t; read: 'ime.components.action-bar'">
  <ng-content></ng-content>
</div>
